function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import emit, { changeEvt } from "./emit";
export var RoleAcl = /*#__PURE__*/function () {
  function RoleAcl(opt) {
    _classCallCheck(this, RoleAcl);

    opt = Object.assign({
      initial: [],
      rules: {},
      ruleFail: '/403'
    }, opt);
    this.role = opt.initial || [];
    this.rules = opt.rules || {};
    this.router = opt.router;
    this.ruleFail = opt.ruleFail;
    this.middleware = opt.middleware;
    this.initRule = opt.initRule;

    if (this.router) {
      this._initRouter();
    }
  }

  _createClass(RoleAcl, [{
    key: "_initRouter",
    value: function _initRouter() {
      var _this = this;

      var router = this.router;
      var ruleFailPath = typeof this.ruleFail === 'string' ? this.ruleFail : this.ruleFail && this.ruleFail.path;
      router.beforeEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
          var routerRule, toruleFail, p;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  if (!(_this.initRule && !_this._initRuleExeced)) {
                    _context.next = 10;
                    break;
                  }

                  _this._initRuleExeced = true;

                  if (!(typeof _this.initRule === 'function')) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 6;
                  return _this.initRule(_this, _this, router);

                case 6:
                  _context.next = 10;
                  break;

                case 8:
                  _context.next = 10;
                  return _this.initRule;

                case 10:
                  if (!_this.middleware) {
                    _context.next = 18;
                    break;
                  }

                  if (!(typeof _this.middleware === 'function')) {
                    _context.next = 16;
                    break;
                  }

                  _context.next = 14;
                  return _this.middleware(_this, router);

                case 14:
                  _context.next = 18;
                  break;

                case 16:
                  _context.next = 18;
                  return _this.middleware;

                case 18:
                  _context.next = 22;
                  break;

                case 20:
                  _context.prev = 20;
                  _context.t0 = _context["catch"](0);

                case 22:
                  if (!(to.path === ruleFailPath)) {
                    _context.next = 24;
                    break;
                  }

                  return _context.abrupt("return", next());

                case 24:
                  if ('rule' in to.meta) {
                    _context.next = 26;
                    break;
                  }

                  return _context.abrupt("return", next());

                case 26:
                  routerRule = to.meta.rule;

                  if (!_this.check(routerRule)) {
                    _context.next = 31;
                    break;
                  }

                  return _context.abrupt("return", next());

                case 31:
                  toruleFail = to.meta.ruleFail;
                  p = toruleFail || ruleFailPath;

                  if (from.path !== p) {
                    next({
                      path: p,
                      query: to.query
                    });
                  }

                case 34:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 20]]);
        }));

        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "clear",
    value: function clear() {
      this.role = [];
      emit.emit(changeEvt);
    }
  }, {
    key: "change",
    value: function change() {
      for (var _len = arguments.length, role = new Array(_len), _key = 0; _key < _len; _key++) {
        role[_key] = arguments[_key];
      }

      if (Array.isArray(role[0])) {
        role = _toConsumableArray(role[0]);
      }

      this.role = role;
      emit.emit(changeEvt);
    }
  }, {
    key: "setRules",
    value: function setRules(v) {
      this.rules = v;
      emit.emit(changeEvt);
    }
  }, {
    key: "check",
    value: function check() {
      for (var _len2 = arguments.length, permissions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        permissions[_key2] = arguments[_key2];
      }

      var allows = this.allowPermissions;

      if (~allows.indexOf('*')) {
        return true;
      }

      if (Array.isArray(permissions[0])) {
        permissions = permissions[0];
      }

      return permissions.some(function (per) {
        return !!~allows.indexOf(per);
      });
    }
  }, {
    key: "currentRoles",
    get: function get() {
      var role = ['*'];

      if (!this.role) {
        return role;
      } else if (Array.isArray(this.role)) {
        role.push.apply(role, _toConsumableArray(this.role));
      } else {
        role.push(this.role);
      }

      return role;
    }
  }, {
    key: "allowPermissions",
    get: function get() {
      var _this2 = this;

      return this.currentRoles.reduce(function (pers, role) {
        var rolePers = _this2.rules[role] || [];

        if (!Array.isArray(rolePers)) {
          pers.push(rolePers);
        } else {
          pers.push.apply(pers, _toConsumableArray(rolePers));
        }

        return pers;
      }, []);
    }
  }]);

  return RoleAcl;
}();
export default function (vm, acl) {
  vm.$acl = acl;

  var listenFn = function listenFn() {
    vm.$forceUpdate();
  };

  emit.on(changeEvt, listenFn);
}